export const MINIMUM_PHONE_LENGTH = 5;
